export const loadingSelector = (state) => state.control.loading
export const snackbarSelector = (state) => state.control.snackbar
export const confirmationDialogSelector = (state) =>
  state.control.confirmation_dialog
